import { IQueryParams } from '../../features/queryParamsSlice';

export const MEGA_SCREENER_ALTERNATE_SCREENER_URL =
  'https://www.clinicalresearch.com/weight-health-studies';

/** Only include when Redux has at least one non-empty query param. */
export function buildQueryParameters(queryParams?: Partial<IQueryParams>) {
  if (!queryParams) return undefined;

  const QueryParameters = {
    utm_source: queryParams.utm_source,
    utm_medium: queryParams.utm_medium,
    utm_content: queryParams.utm_content,
    utm_campaign: queryParams.utm_campaign,
    utm_term: queryParams.utm_term,
    _utmz: queryParams._utmz,
    gclid: queryParams.gclid,
    atid: queryParams.atid,
    pn: queryParams.pn,
    sID: queryParams.sID,
    psecID: queryParams.psecID,
    fbclid: queryParams.fbclid,
  };

  const hasValue = Object.values(QueryParameters).some(
    (value) => typeof value === 'string' && value.trim()
  );

  return hasValue ? QueryParameters : undefined;
}

/** Only include when user is logged in and Redux profile has at least one field. */
export function buildLoggedInUserData(
  isLoggedIn: boolean | undefined,
  profileBasicDetails?: {
    firstName?: string;
    email?: string;
    zipCode?: string;
    dob?: string;
    gender?: string;
    ethnicity?: string;
  }
) {
  if (!isLoggedIn || !profileBasicDetails) return undefined;

  // Extract date only from dob (remove time if present)
  const dobDateOnly = profileBasicDetails.dob
    ? profileBasicDetails.dob.split('T')[0]
    : profileBasicDetails.dob;

  // Handle gender - pass empty string if 'unknown'
  const genderValue =
    profileBasicDetails.gender?.toLowerCase() === 'unknown' ? '' : profileBasicDetails.gender;

  const loggenInUserData = {
    firstName: profileBasicDetails.firstName,
    email: profileBasicDetails.email,
    zipCode: profileBasicDetails.zipCode,
    dob: dobDateOnly,
    gender: genderValue,
    ethnicity: profileBasicDetails.ethnicity,
  };

  const hasValue = Object.values(loggenInUserData).some(
    (value) => value != null && String(value).trim()
  );

  return hasValue ? loggenInUserData : undefined;
}

export function getThemeJson(themeJsonString: string | undefined): any {
  if (!themeJsonString) return undefined;
  try {
    const themeJson = JSON.parse(themeJsonString);
    return typeof themeJson === 'object' && themeJson !== null ? themeJson : {};
  } catch {
    return {};
  }
}
